import DeletePatientButtonContent from '@/components/layout/link/linked-session-list/delete-patient-button-content';
import { editPatientDetailsModalOpenAtom } from '@/components/modal/editPatientProfileDetailsModal.atoms';
import {
  DeletePatientProfileIdAtom,
  UnLinkPatientAllSessionsModalOpenAtom,
} from '@/components/modal/unlink-patient-with-all-sessions-modal';
import { Button, type ButtonProps } from '@heidi/design-system/button';
import { TypographyCaptionBold, TypographyPBold } from '@heidi/design-system/typography';
import { useSetAtom } from 'jotai';
import { useAtom } from 'jotai/index';

interface DeletePatientButtonProps extends ButtonProps {
  patientId: string;
  children: React.ReactNode;
  isCaptionTypography?: boolean;
}

function DeletePatientButton({
  patientId,
  children,
  isCaptionTypography = false,
  variant,
  size,
  ...props
}: DeletePatientButtonProps) {
  const setOpen = useSetAtom(UnLinkPatientAllSessionsModalOpenAtom);
  const setDeletePatientProfileId = useSetAtom(DeletePatientProfileIdAtom);
  const [isPatientDetailsModalOpen, setIsPatientDetailsModalOpen] = useAtom(
    editPatientDetailsModalOpenAtom
  );

  return (
    <Button
      variant={variant ?? 'destructive_soft'}
      size={size ?? 'xs'}
      onClick={() => {
        setOpen(true);
        setDeletePatientProfileId(patientId);
        if (isPatientDetailsModalOpen) {
          setIsPatientDetailsModalOpen(false);
        }
      }}
      {...props}
    >
      {isCaptionTypography ? (
        <TypographyCaptionBold>
          <DeletePatientButtonContent>{children}</DeletePatientButtonContent>
        </TypographyCaptionBold>
      ) : (
        <TypographyPBold>
          <DeletePatientButtonContent>{children}</DeletePatientButtonContent>
        </TypographyPBold>
      )}
    </Button>
  );
}

export default DeletePatientButton;
